
import { defineComponent } from "vue";

export default defineComponent({
	name: "subscription status controller",
});
